import { render, staticRenderFns } from "./BlockCurrentLevel.vue?vue&type=template&id=2f1ffeaa&"
import script from "./BlockCurrentLevel.vue?vue&type=script&lang=js&"
export * from "./BlockCurrentLevel.vue?vue&type=script&lang=js&"
import style0 from "./BlockCurrentLevel.vue?vue&type=style&index=0&id=2f1ffeaa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports